module.exports = __webpack_public_path__ + "img/medType.18690a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/medType.png
// module id = ku76
// module chunks = 0